module.exports = __webpack_public_path__ + "static/media/ws.9be468df.svg";